'use client'

import { useEffect, useRef } from 'react'
import { toast } from 'sonner'
import { useAuth } from '@/lib/auth/context'
import { popPendingCalc } from '@/lib/pending-calc'
import { CALCULO_FORMULA_VERSION } from '@/lib/calculos/version'

/**
 * Montado uma vez no app. Quando o usuário passa a estar autenticado (ex.:
 * acabou de criar conta pelo gatilho de uma calculadora), pega o cálculo
 * pendente e salva no histórico — fechando o loop "salve este cálculo".
 *
 * Falha em SILÊNCIO: se o servidor recusar (shape/schema), não mostra erro
 * pra quem acabou de se cadastrar. Só avisa quando dá certo.
 */
export function PendingCalcSaver() {
  const { user, isLoading } = useAuth()
  const done = useRef(false)

  useEffect(() => {
    if (isLoading || !user || done.current) return
    done.current = true

    const pending = popPendingCalc()
    if (!pending) return

    ;(async () => {
      try {
        const res = await fetch('/api/calculos', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...pending, formulaVersion: CALCULO_FORMULA_VERSION }),
        })
        const data = await res.json().catch(() => null)
        if (res.ok && data?.success) {
          toast.success('Seu cálculo foi salvo!', {
            description: 'Já está no seu histórico.',
          })
        }
        // Falha → silêncio (a conta foi criada, é o que importa).
      } catch {
        // rede — silêncio
      }
    })()
  }, [isLoading, user])

  return null
}
